exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-history-img[data-v-12b6e5ca]{-o-object-fit:contain;object-fit:contain}.order-item-left.order-receipt-modal-sn-wrap[data-v-12b6e5ca]{padding-left:36px;position:relative}.order-srno.order-receipt-modal-sn[data-v-12b6e5ca]{position:absolute;left:0;top:0}", ""]);

// exports
